import { styled } from "@linaria/react"
import { reaction } from "mobx"
import { observer } from "mobx-react-lite"
import { useEffect } from "react"

import { CodingGuidelinesDialogContent } from "@/components/CodingGuidelinesDialog/CodingGuidelinesDialogContent.tsx"
import { Vertical } from "@/components/Flex.ts"
import { useModel } from "@/hooks/useModel.ts"
import { useOrgContext } from "@/hooks/useRootContext.ts"
import { TaskGuidelinesModel } from "@/routes/tasks/TaskViewScene/TaskGuidelinesModel.ts"

import type { TID } from "@/lib/client/generated/TypeDefinitions.ts"
import type { TaskViewModel } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"


export const TaskGuidelinesTab = observer((props: {
  model: TaskViewModel
}) => {
  const context = useOrgContext()

  const guidelinesModel = useModel(() => {
    return new TaskGuidelinesModel(props.model.taskId as TID, context.queries)
  }, [props.model.taskId, context])

  useEffect(() => {
    const dispose = reaction(
      () => props.model.guidelinesReloadSignal.get(),
      () => void guidelinesModel.load()
    )
    return () => dispose()
  }, [props.model, guidelinesModel])

  return (
    <Container>
      <CodingGuidelinesDialogContent model={guidelinesModel} />
    </Container>
  )
})

const Container = styled(Vertical)`
  align-items: flex-start;
  gap: 24px;

  width: 100%;
  height: 100%;
`
